import './LoaderScreen.css';
import { styled, alpha } from '@mui/material/styles';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import clsx from 'clsx';

const MessagesContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  paddingBottom: '4rem',
  paddingInline: '1.8rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',

  '@media (max-height:380px)': {
    display: 'none',
  },
}));

const LoaderScreen = ({ children, status, messages, className, ...props }) => {
  return status === 'loading' || status === 'error' ? (
    <Box
      className={clsx('flex flex-col w-full justify-center items-center relative', className)}
      bgcolor={(theme) => theme.palette.primary.dark}
      {...props}
    >
      <div className="flex justify-center items-center flex-col relative">
        {status === 'error' && (
          <WarningAmberOutlinedIcon
            sx={{
              fontSize: '20rem',
              padding: 0,
              margin: 0,
              color: (_theme) => alpha(_theme.palette.warning.main, 0.75),
            }}
          />
        )}
        {status === 'loading' && (
          <>
            <img width="120" src="/assets/images/brands/brand-compact-white-001.svg" alt="logo" />
            <div id="spinner">
              <div className="bounce1" />
              <div className="bounce2" />
              <div className="bounce3" />
            </div>
          </>
        )}
      </div>
      <MessagesContainer>
        <Typography
          className="text-18 font-semibold"
          sx={{ color: (theme) => theme.palette.primary.contrastText }}
        >
          {status === 'loading' && 'Cargando configuracion...'}
          {Array.isArray(messages) && `\n${messages.join('\n')}`}
        </Typography>
      </MessagesContainer>
    </Box>
  ) : (
    children
  );
};

export default LoaderScreen;
